export default "__VITE_ASSET__BpbCNn8x__"